export const IS_USER_DATA = 'USER_DATA';
export const IS_USER_LOGOUT = 'USER_LOGOUT';

export const userLoginSuccess = ({UserEmail,UserId,isLoggedIn,accessToken,refreshToken, isResetVerify}) => {
    return {
    type: IS_USER_DATA,
    payload: {UserEmail,UserId, isLoggedIn, accessToken,refreshToken, isResetVerify},
}};

export const userLogout = () => ({
    type: IS_USER_LOGOUT,
});